import React, { useState, useEffect } from "react";
import axios from "axios";

/* ── Icons ─────────────────────────────────────────────────── */
const ShoppingBagIcon = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
    strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
    <line x1="3" y1="6" x2="21" y2="6"/>
    <path d="M16 10a4 4 0 0 1-8 0"/>
  </svg>
);

const FilterIcon = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
    strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
  </svg>
);

/* ── Inject keyframe animation once ────────────────────────── */
if (typeof document !== "undefined" && !document.getElementById("fp-products-style")) {
  const s = document.createElement("style");
  s.id = "fp-products-style";
  s.textContent = "@keyframes fp-fade-in { from { opacity:0; transform:scale(0.92); } to { opacity:1; transform:scale(1); } }";
  document.head.appendChild(s);
}

/* ── Product Data (variants grouped) ───────────────────────── */
const PRODUCTS = [
  // 🐶 Dog Food & Treats
  {
    id: 1, category: "Dog Food & Treats", name: "Milky Biscuit", emoji: "🦴",
    variants: [
      { label: "80g",  price: 95  },
      { label: "200g", price: 170 },
    ],
  },
  {
    id: 2, category: "Dog Food & Treats", name: "FP Freeze Dried", emoji: "🍗",
    variants: [
      { label: "Chicken Cubes 50g",  price: 95 },
      { label: "Egg Yolk Cubes 50g", price: 95 },
    ],
  },
  {
    id: 3, category: "Dog Food & Treats", name: "Doggie Biscuit", emoji: "🐕",
    variants: [
      { label: "80g",  price: 95  },
      { label: "200g", price: 170 },
    ],
  },
  {
    id: 4, category: "Dog Food & Treats", name: "Dentastix Dog Treats", emoji: "🦷",
    variants: [
      { label: "Toy Dogs · 60g", price: 135 },
      { label: "Puppy · 56g",    price: 120 },
    ],
  },
  {
    id: 5, category: "Dog Food & Treats", name: "Goodest Dog", emoji: "🥩",
    variants: [
      { label: "Beef & Liver 130g",    price: 55 },
      { label: "Beef w/ Veggie 130g",  price: 55 },
      { label: "Chicken & Liver 130g", price: 55 },
      { label: "Beef w/ Veggies 80g",  price: 45 },
    ],
  },
  {
    id: 6, category: "Dog Food & Treats", name: "Jumbone (Pedigree)", emoji: "🦴",
    variants: [{ label: "1pc", price: 120 }],
  },
  {
    id: 7, category: "Dog Food & Treats", name: "Furrpole Beef Bites", emoji: "🥩",
    variants: [{ label: "500g", price: 120 }],
  },

  // 🐱 Cat Food & Treats
  {
    id: 8, category: "Cat Food & Treats", name: "Cat Treat Temptations", emoji: "😸",
    variants: [
      { label: "Chicken · 75g", price: 135 },
      { label: "Salmon · 75g",  price: 135 },
    ],
  },
  {
    id: 9, category: "Cat Food & Treats", name: "Goodest Cat", emoji: "🐠",
    variants: [
      { label: "Tender Tuna 85g", price: 45 },
      { label: "Chicken 85g",     price: 45 },
      { label: "Mackerel 85g",    price: 45 },
      { label: "Tasty Tuna 100g", price: 120 },
    ],
  },
  {
    id: 10, category: "Cat Food & Treats", name: "Cat Treat Premium Licky", emoji: "🍬",
    variants: [
      { label: "Violet · 8 sticks", price: 160 },
      { label: "Pink · 8 sticks",   price: 160 },
      { label: "Yellow · 8 sticks", price: 160 },
    ],
  },
  {
    id: 11, category: "Cat Food & Treats", name: "Whiskas", emoji: "🐱",
    variants: [
      { label: "Ocean Fish · 80g", price: 40 },
      { label: "Tuna · 80g",       price: 40 },
    ],
  },

  // 🧴 Pet Care Products / Pet Essentials
  {
    id: 12, category: "Pet Care", name: "FP Pet Cologne", emoji: "🌸",
    variants: [{ label: "100ml", price: 95 }],
  },
  {
    id: 13, category: "Pet Care", name: "FP Shampoo", emoji: "🧴",
    variants: [{ label: "1L", price: 100 }],
  },
  {
    id: 14, category: "Pet Care", name: "Toothbrush", emoji: "🪥",
    variants: [{ label: "Colored · 1pc", price: 35 }],
  },
  {
    id: 15, category: "Pet Care", name: "Pet Toothpaste", emoji: "🦷",
    variants: [{ label: "100g", price: 120 }],
  },
  {
    id: 16, category: "Pet Care", name: "Male Diaper", emoji: "🩲",
    variants: [
      { label: "XS", price: 15 },
      { label: "Small", price: 20 },
      { label: "Medium", price: 20 },
      { label: "Large", price: 25 },
      { label: "Extra Large", price: 25 },
    ],
  },
  {
    id: 17, category: "Pet Care", name: "Female Diaper", emoji: "🩲",
    variants: [
      { label: "XS", price: 15 },
      { label: "Small", price: 20 },
      { label: "Medium", price: 20 },
      { label: "Large", price: 25 },
      { label: "Extra Large", price: 25 },
    ],
  },
  {
    id: 18, category: "Pet Care", name: "LC-Vit Syrup", emoji: "💊",
    variants: [{ label: "60ml", price: 120 }],
  },
  {
    id: 19, category: "Pet Care", name: "MDC Premium Herbal Soap", emoji: "🫧",
    variants: [{ label: "135g", price: 60 }],
  },
  {
    id: 20, category: "Pet Care", name: "MDC Topical Healing Cream", emoji: "🧴",
    variants: [{ label: "10g", price: 90 }],
  },
  {
    id: 21, category: "Pet Care", name: "MDC Pure Leaf Extract Spray", emoji: "🌿",
    variants: [{ label: "100ml", price: 130 }],
  },
  {
    id: 22, category: "Pet Care", name: "Pet Toys", emoji: "🎾",
    variants: [{ label: "1pc", price: 90 }],
  },
  {
    id: 23, category: "Pet Care", name: "MDC Ointment", emoji: "🩹",
    variants: [{ label: "Regular", price: 50 }],
  },
];

const CATEGORIES = [
  { id: "All",               label: "All Products",      emoji: "🐾" },
  { id: "Dog Food & Treats", label: "Dog Food & Treats", emoji: "🐶" },
  { id: "Cat Food & Treats", label: "Cat Food & Treats", emoji: "🐱" },
  { id: "Pet Care",          label: "Pet Care",           emoji: "🧴" },
];

const CATEGORY_COLORS = {
  "Dog Food & Treats": { bg: "#fef3c7", border: "#fde68a", text: "#92400e", dot: "#f59e0b" },
  "Cat Food & Treats": { bg: "#fce7f3", border: "#fbcfe8", text: "#831843", dot: "#ec4899" },
  "Pet Care":          { bg: "#d1fae5", border: "#a7f3d0", text: "#064e3b", dot: "#10b981" },
};

/* ── Product Card with variant selector ─────────────────────── */
const ProductCard = ({ product }) => {
  const [selectedIdx, setSelectedIdx] = useState(0);
  const colors = CATEGORY_COLORS[product.category];
  const selected = product.variants[selectedIdx];
  const hasVariants = product.variants.length > 1;

  return (
    <div
      style={{
        background: "rgba(255,255,255,0.92)",
        backdropFilter: "blur(12px)",
        borderRadius: "1.35rem",
        border: "1.5px solid rgba(196,181,253,0.2)",
        overflow: "hidden",
        transition: "all 0.25s",
        boxShadow: "0 4px 16px rgba(124,58,237,0.06)",
        padding: "1.1rem 1.25rem",
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.boxShadow = "0 12px 36px rgba(124,58,237,0.15)";
        e.currentTarget.style.borderColor = "rgba(196,181,253,0.5)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(124,58,237,0.06)";
        e.currentTarget.style.borderColor = "rgba(196,181,253,0.2)";
      }}
    >

      {/* Top row: icon + name + price */}
      <div style={{ display: "flex", alignItems: "center", gap: "0.9rem" }}>
        {/* Photo or Emoji icon — switches based on selected variant */}
        <div style={{
          width: "3.5rem", height: "3.5rem", flexShrink: 0,
          background: `linear-gradient(135deg, ${colors.bg}, white)`,
          border: `1.5px solid ${colors.border}`,
          borderRadius: "0.9rem",
          display: "flex", alignItems: "center", justifyContent: "center",
          overflow: "hidden",
          fontSize: "1.5rem",
          position: "relative",
        }}>
          {(() => {
            const displayUrl = selected?.photoUrl || product.photoUrl;
            return displayUrl ? (
              <img
                key={selectedIdx}
                src={displayUrl}
                alt={selected?.label || product.name}
                style={{
                  width: "100%", height: "100%", objectFit: "cover",
                  animation: "fp-fade-in 0.22s ease",
                }}
              />
            ) : (
              product.emoji || "🐾"
            );
          })()}
        </div>

        {/* Name + category */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.35rem", marginBottom: "0.15rem" }}>
            <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: colors.dot, flexShrink: 0 }} />
            <span style={{ fontSize: "0.65rem", color: colors.text, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.04em" }}>
              {product.category}
            </span>
          </div>
          <h3 style={{ fontSize: "0.92rem", fontWeight: 800, color: "#1f2937", margin: 0, lineHeight: 1.3 }}>
            {product.name}
          </h3>
        </div>

        {/* Price */}
        <div style={{ flexShrink: 0, textAlign: "right" }}>
          <div style={{
            fontSize: "1.15rem", fontWeight: 900, color: "#7C3AED",
            transition: "all 0.2s",
          }}>
            ₱{selected.price.toLocaleString()}.00
          </div>
        </div>
      </div>

      {/* Variant selector pills */}
      {hasVariants && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem" }}>
          {product.variants.map((v, i) => (
            <button
              key={i}
              onClick={() => setSelectedIdx(i)}
              style={{
                padding: "0.3rem 0.75rem",
                borderRadius: "999px",
                fontSize: "0.72rem",
                fontWeight: 700,
                cursor: "pointer",
                transition: "all 0.18s",
                display: "flex",
                alignItems: "center",
                gap: "0.3rem",
                background: selectedIdx === i
                  ? "linear-gradient(135deg, #7C3AED, #EC4899)"
                  : `${colors.bg}`,
                color: selectedIdx === i ? "white" : colors.text,
                boxShadow: selectedIdx === i
                  ? "0 3px 10px rgba(124,58,237,0.35)"
                  : "none",
                border: selectedIdx === i
                  ? "1.5px solid transparent"
                  : `1.5px solid ${colors.border}`,
              }}
            >
              {v.photoUrl && (
                <span style={{
                  width: "14px", height: "14px",
                  borderRadius: "4px",
                  overflow: "hidden",
                  display: "inline-flex",
                  flexShrink: 0,
                  border: selectedIdx === i ? "1px solid rgba(255,255,255,0.5)" : "1px solid rgba(0,0,0,0.1)",
                }}>
                  <img src={v.photoUrl} alt={v.label} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                </span>
              )}
              {v.label}
            </button>
          ))}
        </div>
      )}

      {/* Single variant — just show as tag */}
      {!hasVariants && (
        <div>
          <span style={{
            display: "inline-block",
            padding: "0.25rem 0.65rem",
            borderRadius: "999px",
            fontSize: "0.72rem",
            fontWeight: 700,
            background: colors.bg,
            color: colors.text,
            border: `1.5px solid ${colors.border}`,
          }}>
            {selected.label}
          </span>
        </div>
      )}
    </div>
  );
};

/* ── Main Products Page ─────────────────────────────────────── */
const Products = ({ setActiveTab }) => {
  const [productsList, setProductsList] = useState(PRODUCTS);
  const [activeCategory, setActiveCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    let isMounted = true;
    axios.get("/api/products")
      .then(res => {
        if (isMounted && res.data.success && res.data.data?.length > 0) {
          setProductsList(res.data.data);
        }
      })
      .catch(err => {
        console.error("Error fetching live products:", err);
      });
    return () => { isMounted = false; };
  }, []);

  const filtered = productsList.filter(p => {
    const matchCat = activeCategory === "All" || p.category === activeCategory;
    const matchSearch =
      p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (p.variants || []).some(v => v.label.toLowerCase().includes(searchQuery.toLowerCase()));
    return matchCat && matchSearch;
  });

  return (
    <div style={{ background: "linear-gradient(135deg, #faf5ff 0%, #fdf2f8 50%, #fff7ed 100%)", minHeight: "100vh" }}>
      {/* Hero */}
      <div style={{
        background: "linear-gradient(135deg, #7C3AED 0%, #9333EA 50%, #EC4899 100%)",
        padding: "4rem 1.5rem 3rem", textAlign: "center", position: "relative", overflow: "hidden",
      }}>
        <div style={{ position: "absolute", top: "-4rem", left: "-4rem", width: "20rem", height: "20rem", borderRadius: "50%", background: "rgba(255,255,255,0.08)", filter: "blur(40px)", pointerEvents: "none" }} />
        <div style={{ position: "absolute", bottom: "-3rem", right: "-3rem", width: "16rem", height: "16rem", borderRadius: "50%", background: "rgba(255,255,255,0.06)", filter: "blur(40px)", pointerEvents: "none" }} />
        <div style={{ position: "relative", zIndex: 1 }}>
          <div style={{
            display: "inline-flex", alignItems: "center", gap: "0.5rem",
            background: "rgba(255,255,255,0.15)", backdropFilter: "blur(8px)",
            border: "1px solid rgba(255,255,255,0.25)", borderRadius: "999px",
            padding: "0.4rem 1rem", marginBottom: "1.25rem",
          }}>
            <ShoppingBagIcon size={14} color="white" />
            <span style={{ fontSize: "0.75rem", color: "white", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase" }}>
              Furpect Tails Shop
            </span>
          </div>
          <h1 style={{ fontSize: "clamp(1.8rem, 5vw, 3rem)", fontWeight: 900, color: "white", margin: "0 0 0.75rem", lineHeight: 1.1 }}>
            Our Products
          </h1>
          <p style={{ fontSize: "clamp(0.9rem, 2vw, 1.05rem)", color: "rgba(255,255,255,0.8)", maxWidth: "480px", margin: "0 auto 2rem", lineHeight: 1.6 }}>
            Quality pet food, treats, and care products available in-store at Furpect Tails.
          </p>
          <div style={{ maxWidth: "420px", margin: "0 auto", position: "relative" }}>
            <input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              style={{
                width: "100%", boxSizing: "border-box",
                padding: "0.8rem 1.25rem 0.8rem 2.75rem",
                borderRadius: "1rem", border: "none", outline: "none",
                fontSize: "0.92rem", fontWeight: 500,
                background: "rgba(255,255,255,0.95)", color: "#1f2937",
                boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
              }}
            />
            <span style={{ position: "absolute", left: "0.9rem", top: "50%", transform: "translateY(-50%)", fontSize: "1rem" }}>🔍</span>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "2rem 1.25rem 4rem" }}>
        {/* Category Filters */}
        <div style={{ display: "flex", alignItems: "center", gap: "0.6rem", flexWrap: "wrap", marginBottom: "2rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.4rem", color: "#7C3AED", fontWeight: 700, fontSize: "0.82rem", marginRight: "0.25rem" }}>
            <FilterIcon size={15} color="#7C3AED" /> Filter:
          </div>
          {CATEGORIES.map(cat => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              style={{
                padding: "0.45rem 1rem", borderRadius: "999px", fontWeight: 700,
                fontSize: "0.8rem", border: "none", cursor: "pointer", transition: "all 0.2s",
                background: activeCategory === cat.id
                  ? "linear-gradient(135deg, #7C3AED, #EC4899)"
                  : "rgba(255,255,255,0.85)",
                color: activeCategory === cat.id ? "white" : "#6b7280",
                boxShadow: activeCategory === cat.id
                  ? "0 4px 16px rgba(124,58,237,0.3)"
                  : "0 2px 8px rgba(0,0,0,0.06)",
              }}
            >
              {cat.emoji} {cat.label}
            </button>
          ))}
          <span style={{ marginLeft: "auto", fontSize: "0.8rem", color: "#9ca3af", fontWeight: 600 }}>
            {filtered.length} product{filtered.length !== 1 ? "s" : ""}
          </span>
        </div>

        {/* Product Grid */}
        {filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "5rem 1rem" }}>
            <div style={{ fontSize: "3.5rem", marginBottom: "1rem" }}>🐾</div>
            <h3 style={{ fontWeight: 800, color: "#374151", marginBottom: "0.5rem" }}>No products found</h3>
            <p style={{ color: "#9ca3af" }}>Try a different search term or category.</p>
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "1rem" }}>
            {filtered.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}

        {/* CTA Banner */}
        <div style={{
          marginTop: "3.5rem",
          background: "linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)",
          borderRadius: "1.75rem", padding: "2.5rem 2rem", textAlign: "center",
          position: "relative", overflow: "hidden",
        }}>
          <div style={{ position: "absolute", top: "-2rem", right: "-2rem", width: "10rem", height: "10rem", borderRadius: "50%", background: "rgba(255,255,255,0.08)", filter: "blur(30px)", pointerEvents: "none" }} />
          <div style={{ position: "relative", zIndex: 1 }}>
            <p style={{ fontSize: "1.75rem", marginBottom: "0.4rem" }}>🐶🐱</p>
            <h2 style={{ fontSize: "clamp(1.25rem, 3vw, 1.75rem)", fontWeight: 900, color: "white", marginBottom: "0.6rem" }}>
              Available in-store at Furpect Tails!
            </h2>
            <p style={{ color: "rgba(255,255,255,0.8)", maxWidth: "440px", margin: "0 auto 1.5rem", lineHeight: 1.6, fontSize: "0.92rem" }}>
              Visit us at 96 Gen. Luna St., Tuktukan, Taguig City or book an appointment and ask your groomer for product recommendations.
            </p>
            <button
              onClick={() => setActiveTab("booking")}
              style={{
                background: "white", color: "#7C3AED", border: "none",
                borderRadius: "0.875rem", padding: "0.8rem 1.75rem",
                fontSize: "0.95rem", fontWeight: 800, cursor: "pointer",
                transition: "all 0.2s", boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.05) translateY(-2px)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "scale(1) translateY(0)"; }}
            >
              Book an Appointment 🐾
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
